import SupportModule from "./index";

const supportRoutes = [
  {
    path: "/support/*",
    element: <SupportModule />,
  },
];

export default supportRoutes;
